__turbopack_context__.v({
  "colorChangeLogo": "mortgage-verification-form-module-scss-module__S65g8G__colorChangeLogo",
  "controlRow": "mortgage-verification-form-module-scss-module__S65g8G__controlRow",
  "controls": "mortgage-verification-form-module-scss-module__S65g8G__controls",
  "divider": "mortgage-verification-form-module-scss-module__S65g8G__divider",
  "fadeZoomIn": "mortgage-verification-form-module-scss-module__S65g8G__fadeZoomIn",
  "fileInputRow": "mortgage-verification-form-module-scss-module__S65g8G__fileInputRow",
  "filler": "mortgage-verification-form-module-scss-module__S65g8G__filler",
  "footerFadeOut": "mortgage-verification-form-module-scss-module__S65g8G__footerFadeOut",
  "header": "mortgage-verification-form-module-scss-module__S65g8G__header",
  "headerFadeOut": "mortgage-verification-form-module-scss-module__S65g8G__headerFadeOut",
  "icon": "mortgage-verification-form-module-scss-module__S65g8G__icon",
  "isSubmitted": "mortgage-verification-form-module-scss-module__S65g8G__isSubmitted",
  "list": "mortgage-verification-form-module-scss-module__S65g8G__list",
  "listItem": "mortgage-verification-form-module-scss-module__S65g8G__listItem",
  "loader": "mortgage-verification-form-module-scss-module__S65g8G__loader",
  "mortgageVerificationContainer": "mortgage-verification-form-module-scss-module__S65g8G__mortgageVerificationContainer",
  "preHeader": "mortgage-verification-form-module-scss-module__S65g8G__preHeader",
  "preSection": "mortgage-verification-form-module-scss-module__S65g8G__preSection",
  "preSubmitButton": "mortgage-verification-form-module-scss-module__S65g8G__preSubmitButton",
  "section": "mortgage-verification-form-module-scss-module__S65g8G__section",
  "sectionHeader": "mortgage-verification-form-module-scss-module__S65g8G__sectionHeader",
  "shrinkSection": "mortgage-verification-form-module-scss-module__S65g8G__shrinkSection",
  "spinner": "mortgage-verification-form-module-scss-module__S65g8G__spinner",
  "submitMessage": "mortgage-verification-form-module-scss-module__S65g8G__submitMessage",
  "tooltipContent": "mortgage-verification-form-module-scss-module__S65g8G__tooltipContent",
  "tooltipText": "mortgage-verification-form-module-scss-module__S65g8G__tooltipText",
});
